import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import OpcoesPaginacao from '../comum/OpcoesPaginacao'
import determinarPaginaAtual from '../../actions/cidade/determinarPaginaAtualCidades'
import alterarRegistrosPorPagina from '../../actions/cidade/alterarRegistrosPorPaginaCidades'

export class PaginacaoCidades extends Component {
  render () {
    return <OpcoesPaginacao
      registrosPorPagina={this.props.registrosPorPagina}
      numeroElementos={this.props.total}
      paginaAtual={this.props.paginaAtual}
      determinarPaginaAtual={this.props.determinarPaginaAtual}
      alterarRegistrosPorPagina={this.props.alterarRegistrosPorPagina}/>
  }
}

export function mapDispatchToProps (dispatch) {
  return bindActionCreators({
    determinarPaginaAtual,
    alterarRegistrosPorPagina
  }, dispatch)
}

export function mapStateToProps (state) {
  return {
    paginaAtual: state.paginaAtualCidade,
    total: state.cidades.total,
    registrosPorPagina: state.registrosPorPaginaCidade
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(PaginacaoCidades)
